import { useEffect, useRef } from "react";
import { WidgetInstance } from "friendly-challenge";
import { useTranslation } from "react-i18next";
import { Box } from "@chakra-ui/react";

const Captcha = () => {
  const container = useRef();
  const widget = useRef();
  const { i18n } = useTranslation();
  const { language } = i18n;

  const doneCallback = (solution) => {};

  const errorCallback = (err) => {};

  useEffect(() => {
    if (!widget.current && container.current) {
      widget.current = new WidgetInstance(container.current, {
        startMode: "auto",
        doneCallback: doneCallback,
        errorCallback: errorCallback,
      });
    }

    return () => {
      if (widget.current !== undefined) widget.current.reset();
    };
  }, [container]);

  return (
    <Box p={"1em 0 1em"}>
      <div ref={container} data-lang={language} className="frc-captcha" data-sitekey="FCMSNCDROM73FTCI" />
    </Box>
  );
};

export default Captcha;
